/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Systemsettings_Description1Inputs */

const zh_systemsettings_description1 = /** @type {(inputs: Systemsettings_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`管理应用的外观与语言偏好。这些设置会立即生效。`)
};

const en_systemsettings_description1 = /** @type {(inputs: Systemsettings_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage the app appearance and language preferences. Changes apply immediately.`)
};

const es_systemsettings_description1 = /** @type {(inputs: Systemsettings_Description1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestiona la apariencia de la aplicación y las preferencias de idioma. Los cambios se aplican de inmediato.`)
};

/**
* | output |
* | --- |
* | "Manage the app appearance and language preferences. Changes apply immediately." |
*
* @param {Systemsettings_Description1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const systemsettings_description1 = /** @type {((inputs?: Systemsettings_Description1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Systemsettings_Description1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_systemsettings_description1(inputs)
	if (locale === "en") return en_systemsettings_description1(inputs)
	return es_systemsettings_description1(inputs)
});
export { systemsettings_description1 as "systemSettings_description" }